import { Component, HostBinding, Input } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

/* Animations */
import { SpinnerContentAnimation } from './spinner-content.animation';

@Component({
  selector: 'app-spinner-content',
  templateUrl: './spinner-content.component.html',
  styleUrls: ['./spinner-content.component.scss'],
  animations: SpinnerContentAnimation
})
export class SpinnerContentComponent {
  @Input() isLoading = false;
  @Input() maxHeight = 'auto';
  @Input() maxWidth = 'auto';
  @Input() isDark = false;
  @Input() animate = false;

  @HostBinding('style')
  get myStyle(): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(`display:flex; height: 100%; width: 100%; max-height: ${this.maxHeight}; max-width: ${this.maxWidth}`);
  }

  constructor(private sanitizer: DomSanitizer) {}
}
